<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Configuración Home</h3>

          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-row class="mt-4">
              <b-col cols="12">
                <h4>Foto portada</h4>
              </b-col>
              <b-col cols="4">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen y vista previa'"
                    description="Tamaño recomendado: 768 x 1024 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image_cta'"
                        v-model="$v.form['image_cta'].$model"
                        @input="changedImage('image_ctaURI', $event)"
                        :state="validateStateGlobal('image_cta')"
                        :aria-describedby="'input-image_cta' + '-feedback'"
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['image_ctaURI']"
                          variant="outline-danger"
                          size="sm"
                          @click="removeImage('image_cta', 'image_ctaURI')"
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form['image_ctaURI']"
                      />
                    </div> </b-form-group></b-row
              ></b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col cols="12">
                <h4>Fotos simulador</h4>
              </b-col>
              <b-col cols="3">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen individual'"
                    description="Tamaño recomendado: 800 x 995 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image_simulator_1'"
                        v-model="$v.form['image_simulator_1'].$model"
                        @input="changedImage('image_simulator_1URI', $event)"
                        :state="validateStateGlobal('image_simulator_1')"
                        :aria-describedby="
                          'input-image_simulator_1' + '-feedback'
                        "
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['image_simulator_1URI']"
                          variant="outline-danger"
                          size="sm"
                          @click="
                            removeImage(
                              'image_simulator_1',
                              'image_simulator_1URI'
                            )
                          "
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form['image_simulator_1URI']"
                      />
                    </div> </b-form-group></b-row
              ></b-col>
              <b-col cols="3">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen servilleta'"
                    description="Tamaño recomendado: 800 x 995 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image_simulator_2'"
                        v-model="$v.form['image_simulator_2'].$model"
                        @input="changedImage('image_simulator_2URI', $event)"
                        :state="validateStateGlobal('image_simulator_2')"
                        :aria-describedby="
                          'input-image_simulator_2' + '-feedback'
                        "
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['image_simulator_2URI']"
                          variant="outline-danger"
                          size="sm"
                          @click="
                            removeImage(
                              'image_simulator_2',
                              'image_simulator_2URI'
                            )
                          "
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form['image_simulator_2URI']"
                      />
                    </div> </b-form-group></b-row
              ></b-col>

              <b-col cols="3">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen mantel'"
                    description="Tamaño recomendado: 800 x 995 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image_simulator_3'"
                        v-model="$v.form['image_simulator_3'].$model"
                        @input="changedImage('image_simulator_3URI', $event)"
                        :state="validateStateGlobal('image_simulator_3')"
                        :aria-describedby="
                          'input-image_simulator_3' + '-feedback'
                        "
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['image_simulator_3URI']"
                          variant="outline-danger"
                          size="sm"
                          @click="
                            removeImage(
                              'image_simulator_3',
                              'image_simulator_3URI'
                            )
                          "
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form['image_simulator_3URI']"
                      />
                    </div> </b-form-group></b-row
              ></b-col>

              <b-col cols="3">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen camino de mesa'"
                    description="Tamaño recomendado: 800 x 995 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image_simulator_4'"
                        v-model="$v.form['image_simulator_4'].$model"
                        @input="changedImage('image_simulator_4URI', $event)"
                        :state="validateStateGlobal('image_simulator_4')"
                        :aria-describedby="
                          'input-image_simulator_4' + '-feedback'
                        "
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['image_simulator_4URI']"
                          variant="outline-danger"
                          size="sm"
                          @click="
                            removeImage(
                              'image_simulator_4',
                              'image_simulator_4URI'
                            )
                          "
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form['image_simulator_4URI']"
                      />
                    </div> </b-form-group></b-row
              ></b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col cols="12">
                <h4>Fotos instagram</h4>
              </b-col>
              <b-col :key="i" v-for="i in 12" cols="3">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="`Imagen ${i}`"
                    description="Tamaño recomendado: 280 x 280 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="`image_social_${i}`"
                        v-model="$v.form[`image_social_${i}`].$model"
                        @input="changedImage(`image_social_${i}URI`, $event)"
                        :state="validateStateGlobal(`image_social_${i}`)"
                        :aria-describedby="
                          `input-image_social_${i}` + '-feedback'
                        "
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form[`image_social_${i}URI`]"
                          variant="outline-danger"
                          size="sm"
                          @click="
                            removeImage(
                              `image_social_${i}`,
                              `image_social_${i}URI`
                            )
                          "
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form[`image_social_${i}URI`]"
                      />
                    </div> </b-form-group></b-row
              ></b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col cols="12">
                <b-button type="submit" variant="primary">
                  Guardar opciones</b-button
                >
              </b-col>
            </b-row>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  minLength,
  decimal,
  numeric,
  requiredIf,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';
import { VueEditor } from 'vue2-editor';
const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminWebHomeSettingsScreen',
  mixins: [validationMixin],
  validations() {
    let rules = {
      image_cta: {
        isValidImage,
      },
      image_simulator_1: {
        isValidImage,
      },
      image_simulator_2: {
        isValidImage,
      },
      image_simulator_3: {
        isValidImage,
      },
      image_simulator_4: {
        isValidImage,
      },
    };

    [...Array(12)]
      .map((_, i) => 1 + i * 1)
      .map((x) => {
        rules[`image_social_${x}`] = { isValidImage };
      });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      image_cta: null,
      image_ctaURI: null,

      image_simulator_1: null,
      image_simulator_1URI: null,

      image_simulator_2: null,
      image_simulator_2URI: null,

      image_simulator_3: null,
      image_simulator_3URI: null,

      image_simulator_4: null,
      image_simulator_4URI: null,

      error: {
        show: false,
        text: '',
      },
    };

    [...Array(12)]
      .map((_, i) => 1 + i * 1)
      .map((x) => {
        // Only 'es' lang required
        form['image_social_' + x] = null;
        form['image_social_' + x + 'URI'] = null;
      });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      categoryOptions: [],
      form: form,
      numImages: 5,
      attributeSelectorOptions: {},
      attributeSelectorDefaultOptions: {},
    };
  },
  computed: {},
  created() {
    store.setOverlayShow(true);
    let promises = [];

    promises.push(actions.getPredefinedProductCategoriesUnpaginated());

    Promise.all(promises).then((x) => {
      // 0
      this.categoryOptions = x[0].data.results.map((y) => {
        return {
          value: y.id,
          text: (y.parent_name ? y.parent_name + ', ' : '') + y.reference,
        };
      });

      let self = this;

      actions.getWebHomeSettings(0).then((y) => {
        const data = y.data;

        this.form.image_ctaURI = data.image_cta;
        this.form.image_simulator_1URI = data.image_simulator_1;

        this.form.image_simulator_2URI = data.image_simulator_2;

        this.form.image_simulator_3URI = data.image_simulator_3;

        this.form.image_simulator_4URI = data.image_simulator_4;

        [...Array(12)]
          .map((_, i) => 1 + i * 1)
          .map((x) => {
            // Only 'es' lang required
            this.form[`image_social_${x}URI`] = data[`image_social_${x}`];
          });

        store.setOverlayShow(false);
      });
    });
  },
  methods: {
    removeImage(i, i2) {
      this.form[i] = null;
      this.form[i2] = null;
    },
    swapAttributes(i, j) {
      this.form.variations[i] = this.form.variations.splice(
        j,
        1,
        this.form.variations[i]
      )[0];
    },
    moveUp(i) {
      i = parseInt(i);
      this.swapAttributes(i, i - 1);
    },
    moveDown(i) {
      i = parseInt(i);
      this.swapAttributes(i, i + 1);
    },
    capitalizeWords(string) {
      return string.replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
    },
    changedName(val) {
      this.$v.form.reference.$model = this.capitalizeWords(val);
    },

    validateStateAttributes(index, name) {
      const { $dirty, $error } = this.$v.form.variations.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },

    /* Global */

    removeAttribute(index) {
      this.form.variations.splice(index, 1);
    },

    addAttribute() {
      this.form.variations.push({ name: '', price: '0.0' });
    },

    setDecimal(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.variations.$each.$iter[index][name].$model = val;
      this.$v.form.variations.$each.$iter[index][name].$touch();
    },

    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(i, newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form[i] = result;
      });
    },
    validateStateGlobal(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let data = new FormData();

      if (this.form.image_cta !== null) {
        data.append('image_cta', this.form.image_cta);
      } else if (this.form.image_ctaURI === null) {
        data.append('image_cta', new File([], ''));
      }

      if (this.form.image_simulator_1 !== null) {
        data.append('image_simulator_1', this.form.image_simulator_1);
      } else if (this.form.image_simulator_1URI === null) {
        data.append('image_simulator_1', new File([], ''));
      }

      if (this.form.image_simulator_2 !== null) {
        data.append('image_simulator_2', this.form.image_simulator_2);
      } else if (this.form.image_simulator_2URI === null) {
        data.append('image_simulator_2', new File([], ''));
      }

      if (this.form.image_simulator_3 !== null) {
        data.append('image_simulator_3', this.form.image_simulator_3);
      } else if (this.form.image_simulator_3URI === null) {
        data.append('image_simulator_3', new File([], ''));
      }

      if (this.form.image_simulator_4 !== null) {
        data.append('image_simulator_4', this.form.image_simulator_4);
      } else if (this.form.image_simulator_4URI === null) {
        data.append('image_simulator_4', new File([], ''));
      }

      [...Array(12)]
        .map((_, i) => 1 + i * 1)
        .map((x) => {
          if (this.form[`image_social_${x}`] !== null) {
            data.append(`image_social_${x}`, this.form[`image_social_${x}`]);
          } else if (this.form[`image_social_${x}URI`] === null) {
            data.append(`image_social_${x}`, new File([], ''));
          }
          // Only 'es' lang required
        });

      store.setOverlayShow(true);

      actions.patchWebHomeSettings(data).then((x) => {
        store.setOverlayShow(false);
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
